import { ArrowUpRight } from 'lucide-react'
import type { SiteCopy } from '../../content'

type ContactBlockProps = { copy: SiteCopy['finalCta']; children: React.ReactNode }

export function ContactBlock({ copy, children }: ContactBlockProps) {
  return <section id="contact" className="contact" aria-label={copy.eyebrow}><div className="container contact-shell"><div className="contact-copy" data-testid="contact-close"><p className="eyebrow">{copy.eyebrow}</p><h2 id="contact-title">{copy.title}</h2><p>{copy.body}</p><small>{copy.note}</small><a className="contact-arrow" href="#top">Back to top <ArrowUpRight aria-hidden="true" /></a></div><div>{children}</div></div></section>
}
